/* eslint-disable global-require */

'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./patch.prod');
} else {
  module.exports = require('./patch.dev');
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-loader/lib/patch.js
 ** module id = 2
 ** module chunks = 0
 **/